import React from 'react';

import PulseMonitor from './PulseMonitor.js';
import { plethAmplitude } from './pulseModel.js';

const COLOR = [0, 220, 255];
const sample = (seconds) => 130 - 85 * plethAmplitude(seconds);
// SpO2 is an independent measurement, not inferred from single-channel PPG height.
const readout = () => 98;

const PlethSketch = () => (
  <PulseMonitor
    label="PLETH"
    className="pleth"
    color={COLOR}
    sample={sample}
    readout={readout}
    limits={[90, 100]}
    initialValue={98}
    valueId="pleth-value"
    unit="SpO₂ %"
  />
);

export default PlethSketch;
